import BossModel from "@/models/BossModel";
import Ticket from "@/models/Dossier/Ticket/Ticket";

export default class PnrCode extends BossModel {

    static apiUrl = 'dossier/ticket/pnr-code';

    static entity = 'dossierTicketPnrCodes';

    static fields() {
        return {
            id: this.number(null).nullable(),
            pnr: this.attr(null),
            sfi: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            tickets: this.hasMany(Ticket, 'dossier_ticket_pnr_code_id'),
        }
    }
}
